// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingPaymentListResponse

import { hydrateBillingPayment, type BillingPayment, type BillingPaymentApiResponse } from './billingPayment.gen';

export type BillingPaymentListApiResponse = {
	items: BillingPaymentApiResponse[];
};

export type BillingPaymentList = {
	items: BillingPayment[];
};

export function hydrateBillingPaymentList(data: BillingPaymentListApiResponse): BillingPaymentList {
	return {
		...data,
		items: data.items.map(hydrateBillingPayment),
	};
}